// extracted by mini-css-extract-plugin
module.exports = {"gifts":"Gifts_gifts__rzG_B","headerSection":"Gifts_headerSection__VBoY3","headline":"Gifts_headline__4QeER","subHeadline":"Gifts_subHeadline__IRhDq"};